import * as React from "react";
import { Block, BlockProps } from "baseui/block";
import { LabelMedium } from "../typography";
import { Link as BaseLink } from "../Link";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type LinkProps = {
  href: string;
  text?: string;
  label?: string;
} & unknown;

type LinkListProps = {
  items: LinkProps[];
} & BlockProps;

export function LinkList(props: LinkListProps) {
  const { items = [], ...restProps } = props;
  const [css] = useStyletron();
  return (
    <Block {...restProps}>
      <ul
        className={css({
          margin: 0,
          padding: 0,
        })}
      >
        {items.map((props, i) => (
          <li
            key={i}
            className={css({
              listStyleType: "none",
              marginTop: 0,
              marginRight: 0,
              marginBottom: "15px",
              marginLeft: 0,
              padding: 0,
            })}
          >
            <Link {...props} />
          </li>
        ))}
      </ul>
    </Block>
  );
}

function Link({ href, label, ...restProps }: LinkProps) {
  const Component = href ? BaseLink : LabelMedium;
  return (
    <Component
      href={href}
      $style={{
        color: "white",
        textDecoration: "none",
        ":visited": {
          color: "white",
        },
        ":hover": {
          color: href ? "#aaa" : null,
        },
      }}
      {...restProps}
    >
      {label}
    </Component>
  );
}
